import { useEffect, useRef, useState } from 'react';

/* eslint-disable react-refresh/only-export-components */
const HeadingIcon = ({ size = 15, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.25"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M6 4v16" />
    <path d="M18 4v16" />
    <path d="M6 12h12" />
  </svg>
);

const TextIcon = ({ size = 15, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.25"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <line x1="4" x2="20" y1="6" y2="6" />
    <line x1="4" x2="14" y1="12" y2="12" />
    <line x1="4" x2="18" y1="18" y2="18" />
  </svg>
);

const LogoIcon = ({ size = 15, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);

const ImageIcon = ({ size = 15, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
    <circle cx="9" cy="9" r="2" />
    <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
  </svg>
);

const ButtonIcon = ({ size = 15, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <rect width="20" height="12" x="2" y="6" rx="3" />
    <path d="M8 12h8" />
  </svg>
);

const QuoteIcon = ({ size = 15, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
  >
    <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
  </svg>
);

const SocialIcon = ({ size = 15, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <circle cx="18" cy="5" r="3" />
    <circle cx="6" cy="12" r="3" />
    <circle cx="18" cy="19" r="3" />
    <line x1="8.59" x2="15.42" y1="13.51" y2="17.49" />
    <line x1="15.41" x2="8.59" y1="6.51" y2="10.49" />
  </svg>
);

const DividerIcon = ({ size = 15, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <line x1="3" x2="21" y1="12" y2="12" />
  </svg>
);

const SpacerIcon = ({ size = 15, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <polyline points="8 18 12 22 16 18" />
    <polyline points="8 6 12 2 16 6" />
    <line x1="12" x2="12" y1="2" y2="22" />
  </svg>
);

const FooterIcon = ({ size = 15, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <rect width="18" height="18" x="3" y="3" rx="2" />
    <line x1="3" x2="21" y1="15" y2="15" />
    <line x1="7" x2="17" y1="18" y2="18" />
  </svg>
);

export const BLOCKS = [
  {
    type: 'HEADING',
    icon: HeadingIcon,
    title: 'Heading',
    desc: 'Add a prominent title or heading',
  },
  {
    type: 'TEXT',
    icon: TextIcon,
    title: 'Text',
    desc: 'Add rich paragraph text',
  },
  {
    type: 'LOGO',
    icon: LogoIcon,
    title: 'Logo',
    desc: 'Add company branding logo',
  },
  {
    type: 'IMAGE',
    icon: ImageIcon,
    title: 'Image',
    desc: 'Add photo or banner image',
  },
  {
    type: 'BUTTON',
    icon: ButtonIcon,
    title: 'Button',
    desc: 'Add a call-to-action button',
  },
  {
    type: 'QUOTE',
    icon: QuoteIcon,
    title: 'Quote',
    desc: 'Add a quote or highlighted statement',
  },
  {
    type: 'SOCIAL',
    icon: SocialIcon,
    title: 'Social Icons',
    desc: 'Add social media profile links',
  },
  {
    type: 'DIVIDER',
    icon: DividerIcon,
    title: 'Divider',
    desc: 'Add a subtle separator line',
  },
  {
    type: 'SPACER',
    icon: SpacerIcon,
    title: 'Spacer',
    desc: 'Add blank vertical space',
  },
  {
    type: 'FOOTER',
    icon: FooterIcon,
    title: 'Footer',
    desc: 'Add footer with unsubscribe line',
  },
];

const GROUPS = [
  ['HEADING', 'TEXT'],
  ['LOGO', 'IMAGE', 'BUTTON'],
  ['QUOTE', 'SOCIAL'],
  ['DIVIDER', 'SPACER', 'FOOTER'],
].map((types) => BLOCKS.filter((block) => types.includes(block.type)));

function handleDragStart(e, blockType) {
  e.dataTransfer.setData('text/email-block-type', blockType);
  e.dataTransfer.setData('text/plain', blockType);
  e.dataTransfer.effectAllowed = 'copy';
}

function BlockButton({ block, onAddBlock, swipeRef }) {
  return (
    <button
      type="button"
      onPointerDown={(e) => {
        e.currentTarget.draggable = e.pointerType === 'mouse';
      }}
      onClick={() => {
        if (swipeRef.current) return;
        onAddBlock(block.type);
      }}
      onDragStart={(e) => handleDragStart(e, block.type)}
      className="group flex items-center gap-1.5 h-11 min-w-11 px-2 rounded-md text-gray-600 hover:bg-gray-100 hover:text-primary transition-colors cursor-pointer shrink-0 touch-manipulation focus:outline-none focus:ring-1 focus:ring-primary/40"
      title={block.desc}
      aria-label={`Add ${block.title} block`}
    >
      <span className="text-gray-500 group-hover:text-primary flex items-center justify-center shrink-0">
        <block.icon size={15} />
      </span>
      <span className="text-xs font-medium whitespace-nowrap">
        {block.title}
      </span>
    </button>
  );
}

function Group({ blocks, onAddBlock, showDivider, swipeRef }) {
  return (
    <div className="flex items-center shrink-0">
      {showDivider && <div className="w-px h-5 bg-gray-200 mx-1.5 shrink-0" />}
      {blocks.map((block) => (
        <BlockButton
          key={block.type}
          block={block}
          onAddBlock={onAddBlock}
          swipeRef={swipeRef}
        />
      ))}
    </div>
  );
}

export function EmailBlockToolbar({ onAddBlock, actions }) {
  const scrollerRef = useRef(null);
  const swipeRef = useRef(false);
  const startX = useRef(0);
  const [edges, setEdges] = useState({ left: false, right: false });

  const syncEdges = () => {
    const el = scrollerRef.current;
    if (!el) return;
    setEdges({
      left: el.scrollLeft > 4,
      right: el.scrollLeft + el.clientWidth < el.scrollWidth - 4,
    });
  };

  useEffect(() => {
    const el = scrollerRef.current;
    if (!el) return undefined;
    syncEdges();
    const observer = new ResizeObserver(syncEdges);
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="email-block-shell w-full min-w-0 shrink-0">
      <style>{`
        .email-block-shell { container-type: inline-size; }
        .email-block-bar { display: flex; flex-direction: column; }
        .email-block-actions { display: flex; justify-content: flex-end; gap: 8px; padding: 4px 8px 6px; }
        @container (min-width: 720px) {
          .email-block-bar { flex-direction: row; align-items: center; min-height: 56px; }
          .email-block-actions { padding: 0 12px 0 0; }
        }
      `}</style>
      <div className="email-block-bar relative w-full min-w-0 border-t border-gray-200 bg-white font-sf-pro-display select-none">
        <div className="relative min-w-0 flex-1">
          {edges.left && (
            <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-6 bg-gradient-to-r from-white to-transparent" />
          )}
          {edges.right && (
            <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-6 bg-gradient-to-l from-white to-transparent" />
          )}
          <div
            ref={scrollerRef}
            onScroll={() => {
              swipeRef.current = true;
              syncEdges();
            }}
            onPointerDown={(e) => {
              startX.current = e.clientX;
              swipeRef.current = false;
            }}
            onPointerMove={(e) => {
              if (Math.abs(e.clientX - startX.current) > 8)
                swipeRef.current = true;
            }}
            onPointerUp={() => {
              window.setTimeout(() => {
                swipeRef.current = false;
              }, 80);
            }}
            className="email-block-tools flex h-14 items-center overflow-x-auto overflow-y-hidden px-2 touch-pan-x overscroll-x-contain [scrollbar-width:thin]"
          >
            {GROUPS.map((blocks, index) => (
              <Group
                key={blocks[0].type}
                blocks={blocks}
                onAddBlock={onAddBlock}
                showDivider={index > 0}
                swipeRef={swipeRef}
              />
            ))}
          </div>
        </div>
        {actions && (
          <div className="email-block-actions shrink-0">{actions}</div>
        )}
      </div>
    </div>
  );
}
